import { Array, Boolean, Null, Number, Optional, Record, String, Union, Unknown } from 'runtypes';

import { ActivityExtrasRunType } from 'src/models/activity/extras';
import { AppointmentExtrasRunType } from 'src/models/appointment/extras';
import { DocumentDetailSpoingExtrasRunType, DocumentExtrasRunType } from 'src/models/document/extras';
import { MailExtrasRunType } from 'src/models/mail/extras';
import { MessageExtrasRunType } from 'src/models/message/extras';
import { PhoneCallExtrasRunType, PhoneCallSpoingExtrasRunType } from 'src/models/phoneCall/extras';
import { PhoneCallListExtrasRunType } from 'src/models/phoneCallList/extras';
import { TaskExtrasRunType } from 'src/models/task/extras';

export const SpoingButtonRunType = Record({
	aggregateId: Optional(String),
	aggregateVersion: Optional(Number),
	extras: Union(
		MailExtrasRunType,
		MessageExtrasRunType,
		DocumentExtrasRunType,
		PhoneCallExtrasRunType,
		PhoneCallListExtrasRunType,
		PhoneCallSpoingExtrasRunType,
		TaskExtrasRunType,
		ActivityExtrasRunType,
		DocumentDetailSpoingExtrasRunType,
		AppointmentExtrasRunType
	)
		.Or(Array(Unknown))
		.Or(Null),
	processId: Optional(String),
	render: Optional(Boolean),
	timestamp: Optional(String.Or(Number)).Or(Null),
});
